import type { Session } from '@/types';

export type SessionActionRoute =
  'cal' | 'mento-member' | 'mento-coach' | 'unavailable';

export type SessionActionViewer =
  'owning-member' | 'associated-coach' | 'other';

interface SessionActionRouteInput {
  action: 'cancel' | 'reschedule';
  session: Session;
  viewer: SessionActionViewer;
}

export const sessionActionRoute = ({
  action,
  session,
  viewer,
}: SessionActionRouteInput): SessionActionRoute => {
  const nativeAllowed =
    action === 'cancel'
      ? session.sourceAppointmentCancelAllowed
      : session.sourceAppointmentRescheduleAllowed;

  if (session.sourceAppointmentId) {
    if (nativeAllowed === false) return 'unavailable';
    if (viewer === 'owning-member') return 'mento-member';
    if (viewer === 'associated-coach') return 'mento-coach';
    return 'unavailable';
  }

  if (session.bookingSource === 'cal') return 'cal';

  const isKnownMoments =
    session.bookingSource === 'moments' ||
    session.bookId.startsWith('moments:');
  if (isKnownMoments) {
    return viewer === 'owning-member' && nativeAllowed !== false
      ? 'mento-member'
      : 'unavailable';
  }

  return 'unavailable';
};
